import React, { useState } from 'react';
import { useDeleteDrivers } from '../../hooks/react-query/useDrivers';

import { TrashIcon } from '../../icons';
import { ConfirmationDialog, CustomModal } from '../ui';
import DriverForm from './driverForm';

const DriverOverView = ({
  selectedDriver,
  handleAssignCar,
  handleViewState,
  handleSelectedDriver,
}) => {
  const [openDeletionModal, setDeletionOpenModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const { mutate: deleteDriver, isLoading: isDeleteDriverLoading } =
    useDeleteDrivers();

  const { email, phone, id, firstName, lastName, birthDate, driversLicense } =
    selectedDriver || {};

  const handleDeleteDriver = async () => {
    deleteDriver(id, {
      onSuccess: (data) => {
        handleViewState();
        handleSelectedDriver();
        setDeletionOpenModal(false);
      },
    });
  };

  return (
    <div className="flex flex-col justify-between p-6  h-[500px] bg-white rounded-lg">
      {!selectedDriver && <div className='flex h-full items-center justify-center text-center font-semibold'> 
        Επίλεξε έναν οδηγό για να δεις αναλυτικά στοιχεία.
      </div>}
      <div className="flex flex-col gap-y-14 ">
        {id && (
          <div className="flex flex-col gap-y-6 xl:ps-3.5">
            <h3 className='break-words'>
              {firstName} {lastName}
            </h3>
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1">
                <span className="text-label text-fadedgrey">Email</span>
                <span className="text-body break-words">{email}</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-label text-fadedgrey">Αριθ. τηλεφώνου</span>
                <span className="text-body">{phone}</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-label text-fadedgrey">Ημερομηνία γέννησης</span>
                <span className="text-body">{birthDate && birthDate.split('-')[2]+'/'+birthDate.split('-')[1]+'/'+birthDate.split('-')[0]}</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-label text-fadedgrey">
                  Αριθμός Διπλώματος
                </span>
                <span className="text-body pb-5">{driversLicense}</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-3 self-end items-center">
        <button
          type="button"
          disabled={!id}
          className="btn-secondary px-2 text-secondary-button w-full"
          onClick={handleAssignCar}
        >
          Προσθήκη αυτοκινήτου
        </button>
        <CustomModal
          triggerClass="btn-secondary text-secondary-button w-full px-0"
          triggerComponent={<>Επεξεργασία στοιχείων</>}
          handleClick={(value) => setOpenModal(value)}
          openModal={openModal}
          disabled={!id}
          wrapperClass="max-lg:h-full"
        >
          <div className="container-sm mx-auto lg:py-10 py-5 flex flex-col items-center gap-y-5 max-lg:px-5">
            <div className="flex flex-col gap-10">
              <h3 className="text-center">Επεξεργασία στοιχείων</h3>
              <DriverForm
                mode="edit"
                btnText="Αποθήκευση"
                driversDetails={selectedDriver}
                setSelectedDriver={(values) => { handleSelectedDriver(values) }}
                handleClose={() => setOpenModal(false)}
              />
            </div>
          </div>
        </CustomModal>

        <CustomModal
          triggerClass={`flex items-center justify-center btn-secondary flex gap-2 w-full ${
            id ? 'border-primary' : 'border-fadedgrey'
          }`}
          triggerComponent={
            <>
              <TrashIcon color={!id ? '#a5a5a5' : '#D4002A'} />
              <span
                className={
                  id
                    ? 'text-primary-button text-primary'
                    : 'text-primary-button text-fadedgrey'
                }
              >
                Διαγραφή οδηγού
              </span>
            </>
          }
          handleClick={(value) => setDeletionOpenModal(value)}
          openModal={openDeletionModal}
          disabled={!id}
        >
          <div className="container-sm mx-auto">
            <ConfirmationDialog
              message={
               <p className='text-center'>Είσαι σίγουρος ότι θέλεις να διαγράψεις οριστικά τον/την <span className='font-[700]'> {selectedDriver?.firstName} {selectedDriver?.lastName} </span>από τη συνολική λίστα οδηγών;</p>
              }
              title="Διαγραφή Οδηγού"
              handleOkClick={handleDeleteDriver}
              isLoading={isDeleteDriverLoading}
              handleCancelClick={() => setDeletionOpenModal(false)}
            />
          </div>
        </CustomModal>
      </div>
    </div>
  );
};

export default DriverOverView;
